import { createContext } from 'react';

import type { ReviewResultContextType } from './review-result.types';

export const ReviewResultContext = createContext<ReviewResultContextType>({
  setResult: () => {},
  result: null,
});
